// Dashboard Data
export const dashboardData = {
  overview: {
    totalTillSlips: 6000,
    validHillsSlips: 5580,
    invalidSlips: 420,
    totalSales: "R2,85M",
    averageDiscount: "R475.20",
    uniqueStores: "30+",
    validatorAccuracy: "95%",
    overClaimed: "R50,000",
    underPaid: "R30,000"
  },

  moderators: [
    { name: "Steve Smith", reviewed: 1500, correct: 1450, accuracy: 97, inaccurate: 50 },
    { name: "Bob Smith", reviewed: 1300, correct: 1250, accuracy: 96, inaccurate: 50 },
    { name: "Susan Smith", reviewed: 1700, correct: 1650, accuracy: 97, inaccurate: 50 },
    { name: "Joe Bloggs", reviewed: 1200, correct: 1150, accuracy: 96, inaccurate: 50 },
    { name: "Mary Bloggs", reviewed: 1400, correct: 1380, accuracy: 99, inaccurate: 20 },
    { name: "Keith Blogs", reviewed: 1600, correct: 1550, accuracy: 97, inaccurate: 50 }
  ],

  stores: [
    { name: "TAH - Vetpoint", claims: 500, correct: 490, accuracy: 98, overClaimed: 5, underPaid: 5 },
    { name: "TAH - Sitari Village", claims: 480, correct: 465, accuracy: 97, overClaimed: 10, underPaid: 5 },
    { name: "St Heliers Veterinary Hospital", claims: 510, correct: 500, accuracy: 98, overClaimed: 7, underPaid: 3 },
    { name: "TAH - Ou Kaapse Vet", claims: 520, correct: 500, accuracy: 96, overClaimed: 12, underPaid: 8 },
    { name: "Ashburne Veterinary Clinic", claims: 495, correct: 480, accuracy: 97, overClaimed: 10, underPaid: 5 },
    { name: "TAH - Goodwood", claims: 505, correct: 490, accuracy: 97, overClaimed: 8, underPaid: 7 },
    { name: "TAH - Durban North", claims: 530, correct: 510, accuracy: 96, overClaimed: 15, underPaid: 5 },
    { name: "TAH - Radiokop Animal Clinic", claims: 500, correct: 490, accuracy: 98, overClaimed: 5, underPaid: 5 },
    { name: "Frystraat Animal Hospital", claims: 480, correct: 470, accuracy: 98, overClaimed: 4, underPaid: 6 },
    { name: "TAH - Belmont", claims: 510, correct: 500, accuracy: 98, overClaimed: 7, underPaid: 3 }
  ],

  topPerformingStores: [
    { name: "TAH - Vetpoint", accuracy: 98 },
    { name: "TAH - Sitari Village", accuracy: 97 },
    { name: "St Heliers Veterinary Hospital", accuracy: 97 },
    { name: "TAH - Ou Kaapse Vet", accuracy: 96 },
    { name: "Ashburne Veterinary Clinic", accuracy: 96 },
    { name: "TAH - Goodwood", accuracy: 95 },
    { name: "TAH - Durban North", accuracy: 95 },
    { name: "TAH - Radiokop Animal Clinic", accuracy: 94 },
    { name: "Frystraat Animal Hospital", accuracy: 94 },
    { name: "TAH - Belmont", accuracy: 93 }
  ],

  worstPerformingStores: [
    { name: "Boskruin Veterinary Clinic", accuracy: 85 },
    { name: "Rivonia Village Veterinary Clinic", accuracy: 84 },
    { name: "Steenberg Veterinary Clinic", accuracy: 83 },
    { name: "TAH - Sonstraal", accuracy: 82 },
    { name: "St Johns Veterinary Clinic", accuracy: 81 },
    { name: "Umhlanga Veterinary Hospital", accuracy: 80 },
    { name: "Companion Healthcare Vet Practice Inc t/a Scottburgh Veterinary Clinic", accuracy: 79 },
    { name: "Bryanston Veterinary Hospital", accuracy: 78 },
    { name: "Hayfields Veterinary Hospital", accuracy: 77 },
    { name: "Petworld & Vetworld HO t/a Petworld Somerset West Pty Ltd", accuracy: 76 }
  ],

  purchaseCategories: [
    { species: "Dog", lifeStage: "Adult", percentage: "40%", avgSpend: "R1,650" },
    { species: "Cat", lifeStage: "Kitten", percentage: "22%", avgSpend: "R1,050" },
    { species: "Dog", lifeStage: "Senior", percentage: "18%", avgSpend: "R1,450" },
    { species: "Cat", lifeStage: "Adult", percentage: "20%", avgSpend: "R1,250" }
  ],

  hillsProducts: [
    { product: "Hill's Science Plan Canine Adult - Dry Food", species: "Dog", lifeStage: "Adult", purchases: 482 },
    { product: "Hill's Science Plan Canine Adult - Wet Food", species: "Dog", lifeStage: "Adult", purchases: 293 },
    { product: "Hill's Science Plan Canine Puppy - Dry Food", species: "Dog", lifeStage: "Puppy", purchases: 238 },
    { product: "Hill's Science Plan Canine Mature Adult - Dry Food", species: "Dog", lifeStage: "Mature", purchases: 195 },
    { product: "Hill's Prescription Diet for Dogs", species: "Dog", lifeStage: "Adult", purchases: 142 },
    { product: "Hill's Science Plan Feline Adult - Dry Food", species: "Cat", lifeStage: "Adult", purchases: 387 },
    { product: "Hill's Science Plan Feline Kitten - Dry Food", species: "Cat", lifeStage: "Kitten", purchases: 342 },
    { product: "Hill's Prescription Diet for Cats", species: "Cat", lifeStage: "Adult", purchases: 95 }
  ],

  shareOfBasket: [
    { product: "Hill's", spend: "R2,85M", share: 88 },
    { product: "Royal Canin", spend: "R130K", share: 4 },
    { product: "Montego", spend: "R97K", share: 3 },
    { product: "Eukanuba", spend: "R97K", share: 3 },
    { product: "Other", spend: "R65K", share: 2 }
  ],

  competitors: [
    { brand: "Royal Canin", mentions: 1864 },
    { brand: "Eukanuba", mentions: 1400 },
    { brand: "Montego", mentions: 1190 },
    { brand: "Ultra Pet", mentions: 800 },
    { brand: "Acana", mentions: 400 },
    { brand: "Bobtail", mentions: 350 },
    { brand: "Jock", mentions: 300 },
    { brand: "Canine Cuisine", mentions: 250 }
  ],

  complementaryProducts: [
    { product: "Pedigree Dentastix", mentions: 80 },
    { product: "Feeding Bowls", mentions: 74 },
    { product: "Dog Leashes", mentions: 62 },
    { product: "Treats (various)", mentions: 98 }
  ],

  accessories: [
    { product: "Leashes", value: 80 },
    { product: "Dog Beds", value: 70 },
    { product: "Feeding Bowls", value: 60 },
    { product: "Grooming Kits", value: 50 }
  ]
};

export const chartColors = {
  primary: '#002E6D',
  success: '#4CAF50',
  danger: '#CE060D',
  info: '#0077C8',
  secondary: '#004A99',
  light: '#8BC34A'
}; 